import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

import BaseLink from "@components/Link";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import StackContent from "../StackContent";

export interface Props {
  type: "how-it-works-horizontal";
  title?: string;
  description?: string;
  ctaUrl?: string;
  ctaLabel?: string;
  image: string;
  reverseColor?: boolean;
}

const HowItWorksHorizontal: FC<Props> = ({
  title = "How it works",
  description,
  ctaLabel = "Learn more",
  ctaUrl,
  image,
  reverseColor = false,
}) => {
  return (
    <StackContent
      stackMargin={true}
      sx={{
        padding: "64px",
        backgroundColor: reverseColor
          ? Colors.PrimaryContrast
          : Colors.BlueGrey,
        borderRadius: "15px",
        gap: "48px",
        flexDirection: {
          xs: "column",
          md: "row",
        },
      }}
    >
      <Stack
        sx={{
          justifyContent: "center",
          gap: "24px",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "48px",
          }}
        >
          {title}
        </Typography>

        {description && (
          <Typography
            variant="h6"
            mt={2}
            sx={{ color: Colors.TextPrimary, whiteSpace: "pre-wrap" }}
          >
            {description}
          </Typography>
        )}

        {ctaUrl && <BaseLink url={ctaUrl}>{ctaLabel}</BaseLink>}
      </Stack>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: "relative",
          height: "100%",
        }}
      >
        <Box
          component="img"
          src={image}
          sx={{
            width: {
              xs: "100%",
              md: "400px",
              lg: "500px",
            },
          }}
        />
      </Stack>
    </StackContent>
  );
};

export default HowItWorksHorizontal;
